// Module
var code = " <imported-content-host></imported-content-host> ";
// Exports
module.exports = code;